import type {DomainsBaseStyles} from '../../types'
import {defaultStyles} from '../default-styles'

export const theBestReviewsStyles: DomainsBaseStyles = {
  ...defaultStyles,
}
